import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Globe, Instagram } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="relative py-24 bg-dark overflow-hidden" data-id="element-141" data-mp="356lrx9b9o74s">
      {/* Abstract background element */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-orange/5 blur-3xl" data-id="element-142" data-mp="318o347lern1x"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-96 h-96 rounded-full bg-orange/5 blur-3xl" data-id="element-143" data-mp="2w9tkp6rcs0ic"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-144" data-mp="3oweai2s6k4js">
        <h2 className="text-4xl md:text-6xl font-display text-white mb-6" data-id="element-145" data-mp="3k5ftf0zdb2fh">
          Ready to Experience{' '}
          <span className="text-orange" data-id="element-146" data-mp="3f6ky4zk7rleh">Professional Service?</span>
        </h2>

        <p className="text-xl text-slate-400 mb-12 max-w-2xl mx-auto" data-id="element-147" data-mp="3f4i9ojypm0bv">
          Call or visit us today. Walk-ins are welcome, but priority is given to
          appointments.
        </p>

        <div className="mb-12" data-id="element-148" data-mp="bnjcd869cffg">
          <a href="tel:9548710290" className="text-5xl md:text-7xl font-display text-white hover:text-orange transition-colors" data-id="element-149" data-mp="3jv2uuwrvh61c">
            954-871-0290
          </a>
        </div>

        <motion.div animate={{
        scale: [1, 1.05, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} className="inline-block mb-16" data-id="element-150" data-mp="3b42ic3jx46q7">
          <a href="tel:9548710290" className="inline-flex items-center justify-center px-10 py-5 text-xl font-bold rounded-md text-white bg-orange hover:bg-orange/90 transition-all shadow-xl shadow-orange/20" data-id="element-151" data-mp="3646ga9us6pda">
            Click to Call Now
          </a>
        </motion.div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-6 sm:gap-8 text-slate-400 flex-wrap" data-id="element-152" data-mp="qdbk8ys1os4p">
          <div className="flex items-center" data-id="element-153" data-mp="uex5p8inaeqi">
            <MapPin className="w-5 h-5 mr-2 text-orange" data-id="element-154" data-mp="ucja8yk1z0if" />
            <span data-id="element-155" data-mp="23cn5eybu3fnz">Palm Beach County, FL</span>
          </div>
          <div className="hidden sm:block w-1 h-1 bg-slate-600 rounded-full" data-id="element-156" data-mp="1ychbfbi3dh2q"></div>
          <div className="flex items-center" data-id="element-157" data-mp="1yelks8yrf8ae">
            <Globe className="w-5 h-5 mr-2 text-orange" data-id="element-158" data-mp="1ua478riztr82" />
            <span data-id="element-159" data-mp="1ucqmzeg1fd1d">palmbeachpowerstroke.com</span>
          </div>
          <div className="hidden sm:block w-1 h-1 bg-slate-600 rounded-full" data-id="element-160" data-mp="1pddq00vgcpl2"></div>
          <a href="https://instagram.com/PalmBeachPowerstroke" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-orange transition-colors" data-id="element-161" data-mp="2m10jpr155tut">
            <Instagram className="w-5 h-5 mr-2 text-orange" data-id="element-162" data-mp="2d7xbbx5cs771" />
            <span data-id="element-163" data-mp="289lyrenobil4">@PalmBeachPowerstroke</span>
          </a>
        </div>
      </div>
    </section>;
}